<template>
  <div
    class="player-cover"
    @click="getContent">
    <div class="player-cover-action">
      <div
        v-if="loading"
        class="preloader-wrapper">
        <f7-preloader
          color="white" />
      </div>
      <FlatIcon
        v-else
        :size="32"
        :name="icon" />
    </div>
    <div class="player-cover-image">
      <slot />
    </div>
  </div>
</template>

<script>
import { article } from '@/services/atlastories'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PlayerCover',
  props: {
    marker: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      speechInstance: 'speech/speechInstance',
      currentPoiId: 'speech/currentPoiId',
      paused: 'speech/paused',
      reading: 'speech/reading'
    }),
    currentlyReading () {
      return this.currentPoiId === this.marker._id && !this.paused
    },
    icon () {
      return this.currentlyReading ? 'pause-white' : 'play-white'
    }
  },
  methods: {
    ...mapActions({
      initializeSpeech: 'speech/initializeSpeech',
      startMarkerPlaylist: 'speech/startMarkerPlaylist',
      stopCurrentPlaylist: 'speech/stopCurrentPlaylist',
      pause: 'speech/pause',
      resume: 'speech/resume'
    }),
    getContent () {
      if (this.currentlyReading) {
        // already setted and reading, just pause
        this.pause()
        this.$emit('pause')
      } else if (this.currentPoiId === this.marker._id && this.paused) {
        // already setted playlist, just resume speech
        this.resume()
        this.$emit('play')
      } else if (!this.loading && !this.currentlyReading) {
        if (this.reading) {
          this.stopCurrentPlaylist()
        }
        // get the content and setup the playlist
        this.loading = true
        article(this.marker.wiki).then(res => {
          this.loading = false
          this.$emit('load', { marker: this.marker, data: res.data })
          const article = res.data
          // const title = article.title
          // const poiId = this.poiId
          const contentHead = { subtitle: article.title, text: article.summary }
          const contentBody = article.content.reduce((acc, item) => {
            if (item.content) acc.push({ subtitle: item.title, text: item.title + '... ' + item.content })
            if (item.items.length) {
              for (const paragraph of item.items) {
                const subtitle = paragraph.title
                const text = paragraph.title + '... ' + paragraph.content
                acc.push({ subtitle, text })
              }
            }
            return acc
          }, [])
          const playlist = [contentHead, ...contentBody]
          const marker = this.marker
          this.startMarkerPlaylist({ marker, playlist })
            .then(res => {
              this.$emit('play')
            })
        })
          .catch(err => {
            this.loading = false
            this.$emit('error', err.message)
          })
      }
    }
  }
}
</script>

<style lang="scss">
.player-cover {
  position: relative;
  display: inline-block;
  overflow: hidden;
  min-height: 1px;
  cursor: pointer;
  .player-cover-action {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    padding: 6px;
    border-radius: 50%;
    background: rgba(black, .7);
    width: 30px;
    height: 30px;
  }
  .preloader-wrapper {
    position: absolute;
    top: 10px;
    left: 8px;
    transform: translate(-50%,-50%);
  }
  .cloud-image {
    .loader {
      top: 18px;
      left: 16px;
    }
  }
  .player-cover-image {
    line-height: 0;
  }
}
</style>
